<template>
  <main class="page" :class="info && !info.is_finish ? 'no-tabs' : 'plain'">
    <page-header title="任务详情" back @back="$router.back()" />
    <div v-if="loading" class="loading-state">
      <span class="spinner" />
      正在读取任务
    </div>
    <p v-if="error" class="error-message">
      {{ error }}
      <button v-if="!info" class="text-button" @click="load">重试</button>
    </p>
    <template v-if="info">
      <section class="surface">
        <span class="tag" :class="{ soft: !info.is_finish }">{{ info.is_finish ? '已完成' : '待完成' }}</span>
        <h2 class="d-title" style="font-size:20px">{{ info.title }}</h2>
        <p class="task-copy">{{ info.start_content }}</p>
      </section>
      <section class="d-next">
        <div>
          <small>开始时间</small>
          <strong :class="{ empty: !info.start_time }">{{ info.start_time || '未设置' }}</strong>
        </div>
        <div>
          <small>截止时间</small>
          <strong :class="{ empty: !info.end_time }">{{ info.end_time || '未设置' }}</strong>
        </div>
      </section>
      <template v-if="info.is_finish">
        <div class="sec-head">
          <h2>完成情况</h2>
        </div>
        <p class="surface task-copy" style="margin-top:0">{{ info.end_content || '已完成' }}</p>
      </template>
      <template v-else>
        <div class="sec-head">
          <h2>完成情况</h2>
          <span>{{ draftStatus }}</span>
        </div>
        <follow-up-editor v-model="content" title="任务完成情况" input-label="任务完成情况" placeholder="记录完成了哪些工作、当前结果和需要协同的事项……" :ai="false" :disabled="saving" />
        <div class="dock">
          <div class="dock-inner single">
            <button class="button" :disabled="saving" @click="finish">
              <span v-if="saving" class="spinner" />
              <app-icon v-else name="check" />
              {{ saving ? '正在提交' : '确认完成任务' }}
            </button>
          </div>
        </div>
      </template>
    </template>
  </main>
</template>
<script>
import FollowUpEditor from '../../components/follow-up-editor'
import { employee } from '../../common/session'
import { draftKey, readDraft, writeDraft, removeDraft } from '../../common/draft'
export default {
  components: { FollowUpEditor },
  data() {
    return {
      info: null,
      loading: false,
      error: '',
      content: '',
      initial: '',
      key: '',
      saving: false,
      committed: false,
      draftStatus: '填写内容会自动保留为草稿'
    }
  },
  watch: {
    content() {
      if (this.info && !this.committed) this.persist()
    }
  },
  created() {
    this.load()
    window.addEventListener('pagehide', this.persist)
    window.addEventListener('beforeunload', this.unload)
  },
  beforeDestroy() {
    this.persist()
    window.removeEventListener('pagehide', this.persist)
    window.removeEventListener('beforeunload', this.unload)
  },
  beforeRouteLeave(to, from, next) {
    if (this.persist()) {
      next()
      return
    }
    this.$dialog
      .confirm({ title: '草稿无法保留', message: '当前浏览器无法保留填写内容，是否离开？' })
      .then(() => next(), () => next(false))
  },
  methods: {
    async load() {
      this.loading = true
      this.error = ''
      try {
        const profile = await employee(this.$store)
        this.info = await this.$api.post('/api/employee/task/detail', { id: this.$route.params.id })
        this.initial = this.info.end_content || ''
        this.key = draftKey(profile.id, 'task', this.info.id)
        const draft = readDraft(this.key)
        this.content =
          !this.info.is_finish && draft && typeof draft.value === 'string'
            ? draft.value
            : this.initial
        if (draft) this.draftStatus = '已恢复上次填写的草稿'
      } catch (e) {
        this.error = e.message
      } finally {
        this.loading = false
      }
    },
    persist() {
      if (!this.key || !this.info || this.info.is_finish || this.committed) return true
      if (this.content === this.initial) return removeDraft(this.key)
      const ok = writeDraft(this.key, this.content)
      this.draftStatus = ok ? '草稿已保留' : '当前浏览器无法保留草稿，请及时提交'
      return ok
    },
    unload(e) {
      if (!this.persist()) {
        e.preventDefault()
        e.returnValue = ''
      }
    },
    async finish() {
      if (this.saving || !this.info || this.info.is_finish) return
      if (!this.content.trim()) {
        this.$toast('请先填写任务完成情况')
        return
      }
      this.saving = true
      this.error = ''
      try {
        await this.$dialog.confirm({
          title: '确认完成任务',
          message: '提交后此任务将标记为已完成，是否继续？'
        })
        await this.$api.post('/api/employee/task/finish', {
          id: this.info.id,
          end_content: this.content.trim()
        })
        this.committed = true
        removeDraft(this.key)
        this.$store.commit('refreshData')
        this.$toast('任务已完成')
        this.$router.replace('/task')
      } catch (e) {
        if (e && e.message) this.error = e.message
      } finally {
        this.saving = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/task/edit.vue